import awsExports from './aws-exports'

export const getAmplifyEnv = () => awsExports

